module.exports = __webpack_public_path__ + "static/img/VN.acb8222c.jpg";